import { Layout, Typography } from "antd";
import DiscordLink from "./DiscordLink.js";
import "./SiteFooter.css";

export default function SiteFooter() {
  return (
    <Layout.Footer className="site-footer">
      <div className="site-footer-content">
        <Typography.Text type="secondary">© 2026 Age of Companies</Typography.Text>
        <DiscordLink size={24} />
        <span>
          Icons by <a href="https://game-icons.net/" target="_blank" rel="noreferrer">game-icons</a>
        </span>
      </div>
    </Layout.Footer>
  );
}
